/**
 * The footnote list of /audience: under box 2 (the two rules, then the notes about the data), and under the empty card
 * (rules-04 A3, the notes about the data alone). One list, so the two places cannot drift.
 *
 * @module components/audience/AudienceNotes
 */
import React from 'react';

export const AudienceNotes: React.FC<{ notes: readonly string[] }> = ({ notes }) => (
  <ul data-audience-notes className="mt-3 list-disc space-y-1 pl-5 text-xs text-neutral-700">
    {notes.map((note) => <li key={note}>{note}</li>)}
  </ul>
);
